const initialState = {
    isCheckingDuplicates: false
};

export default initialState;
